window.Vivense = window.Vivense || {};

Vivense.favoriteActions = (function($) {

    var exports = {};

    function addFavorite(productId, category, productSku, productCheckbox){
        var postData = {
            productId: productId,
            addedPage : '',
            formToken:window.formToken
        };

        if(window.currentPage){
            postData.addedPage = window.currentPage
        }

        $.post('/index.php?option=com_users&task=setUserProductFavorite', $.param(postData))
            .done(function (response) {
                var res = JSON.parse(response)
                if(res.success){
                    window.favoriteProducts = JSON.stringify(res.favoriteProducts);

                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        'Category': 'Favoriler',
                        'Action': category ? category : '',
                        'Label': window.currentPage === 'product' ? 'Detail' : 'Listing',
                        'noninteraction': true,
                        'event': 'gaEvent'
                    });
                    window.dataLayer.push({
                        event: "add_to_wishlist",
                        ecommerce: {
                        currency: "TRY",
                        value: productCheckbox.data('price') ? productCheckbox.data('price') : 0, // Ürün fiyatı
                        items:  [
                            {
                            item_id: productSku,
                            item_name: productCheckbox.data('product-name'),
                            currency: "TRY",
                            item_brand: productCheckbox.data('product-brand') ? productCheckbox.data('product-brand') : "Vivense",
                            item_category: productCheckbox.data('category') ? productCheckbox.data('category') : "",
                            item_list_name: "",
                            item_variant: "",
                            price: productCheckbox.data('product-price') ? productCheckbox.data('product-price') : 0,
                            quantity: 1
                            }
                        ]
                        }
                    });
                    /* Personaclick: Adding a product to the wishlist */
                    personaclick("track", "wish", productSku);
                }

                if(parseInt(window.userId) === 0 ){
                    window.location.href = '/vivense-uye-kayit.html';
                }
            });

    }

    function removeFromFavorite(productId, productSku){
        var postData = {
            productId:productId,
            formToken:window.formToken
        };

        $.post('/index.php?option=com_users&task=deleteUserProductFavorite', $.param(postData)).done(function (response) {
            var res = JSON.parse(response)
            if(res.success){
                window.favoriteProducts = JSON.stringify(res.favoriteProducts);

                /* Personaclick: Removing a product from the wishlist */
                personaclick("track", "remove_wish", productSku);
            }
        });
    }

    function initFavoriteProducts(){
        var products = JSON.parse(window.favoriteProducts);

        for(var i=0;i<products.length;i++){

            $(".favorite-area-hearth input[type=checkbox][value="+products[i]+"]").prop('checked',true);
        }
    }

    function init(){

        $(".favorite-area-hearth input[type=checkbox]").on('click', function(e){

            var checkbox = $(this);

            e.stopPropagation();

            if(checkbox.prop("checked")){

                addFavorite(checkbox.val(), checkbox.data('category'), checkbox.data('product-sku'), checkbox);

                return;
            }

            removeFromFavorite(checkbox.val(), checkbox.data('product-sku'));
        });

        initFavoriteProducts();
    }

    $(document).ready(init);

    exports.init = init;
    exports.addFavorite = addFavorite;
    exports.initFavoriteProducts = initFavoriteProducts;

    return exports;

})(jQuery);